import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { AdminService } from '../../../services/admin.service';
import { AdminTransactionRow } from '../../../models/admin-transaction.model';

/** Note: the design reference showed a "Status" column (e.g. "Completed")
 *  the confirmed transaction contract has no status field at all, so
 *  that's not shown here rather than invented. Balance-after is real and
 *  arguably more useful anyway. */
@Component({
  selector: 'app-transactions-preview-card',
  standalone: false,
  templateUrl: './transactions-preview-card.html',
})
export class TransactionsPreviewCard implements OnInit, OnDestroy {
  private readonly _destroy$ = new Subject<void>();

  rows: AdminTransactionRow[] = [];
  isLoading = true;

  constructor(private adminService: AdminService) {}

  ngOnInit(): void {
    this.adminService.getTransactions({ perPage: 5 })
      .pipe(takeUntil(this._destroy$))
      .subscribe(({ rows }) => {
        this.rows = rows;
        this.isLoading = false;
      });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
